<template>

<div tabindex="0" class="e-card" id="price">
  <div class="e-card-title" style="display: inline-block">Cancel / Write Off Transaction</div>
    <div>
      <div class="e-card-content">
        <div class="container2">
            <div class="leftcol">
                <div class="form-row" style="display:none;" >
                    <div class="form-row-input">
                    Invoice ID: {{invoiceId}}
                    </div>
                </div>

                <div class="colrow data-flex-row">
                <div style="width:35%;" class="data-flex-cell">
                    <h4>Applicant Name:</h4>
                </div>
                <div style="width:45%;" class="data-flex-cell">
                    <h5>{{requestor}}</h5>
                </div>
                </div>
                <div class="colrow data-flex-row">
                <div style="width:35%;" class="data-flex-cell">
                    <h4>Applicant Company:</h4>
                </div>
                <div style="width:45%;" class="data-flex-cell">
                    <h5>{{selectedInvoiceCompany}}</h5>
                </div>
                </div>

                <div class="colrow data-flex-row">
                <div style="width:35%;" class="data-flex-cell">
                    <h4>Status:</h4>
                </div>
                <div style="width:45%;" class="data-flex-cell">
                    <h5>{{selectedInvoice.invoiceStatus}}</h5>
                </div>
                </div>
            </div>
            <div class="middlecol">
                <div class="colrow data-flex-row">
                <div style="width:35%;" class="data-flex-cell">
                    <h4>Invoice Number:</h4>
                </div>
                <div style="width:45%;" class="data-flex-cell">
                    <h5>{{selectedInvoice.invoiceNumber}}</h5>
                </div>
                </div>
                <div class="colrow data-flex-row">
                <div style="width:35%;" class="data-flex-cell">
                    <h4>Invoice Date:</h4>
                </div>
                <div style="width:45%;" class="data-flex-cell">
                    <h5>{{getDateStringNoTime(selectedInvoice.invoiceDate)}}</h5>
                </div>
                </div>

                <div class="colrow data-flex-row">
                <div style="width:35%;" class="data-flex-cell">
                    <h4>Invoice Amount:</h4>
                </div>
                <div style="width:45%;" class="data-flex-cell">
                    <h5>{{format_currency(selectedInvoice.invoiceAmount)}}</h5>
                </div>
                </div>
            </div>
        </div>
        <div class="container2">
            <div class="leftcol">
                <div class="form-row colrow">
                <div style="width:50%;" class="form-row-input">
                    <ejs-datepicker
                    float-label-type="Always"
                    v-model="selectedInvoice.CancelRefundMetDate"
                    :placeholder="dateMarker"
                    :format="dateFormat"/>
                </div>
                </div>

                <div class="form-row colrow">
                <div style="width:50%;" class="form-row-input">
                    <ejs-textbox
                    float-label-type="Always"
                    placeholder="Cancel/WriteOff Reason:"
                    :multiline="true"
                    rows=6
                    v-model="selectedInvoice.cancelRefundReason"
                    />
                </div>
                </div>
            </div>
            <div class="middlecol">
              <div
                    style="width: 35%"
                    v-for="(method, index) in cancellMethods"
                    :key="index"
                  >
                  <label class="radio-container">
                    <input
                      class="radio-button"
                      :value="method"
                      :htmlAttributes="{ value: method }"
                      type="radio"
                      v-model="cancellMethod"
                      name="cmethod"
                      >
                      <span class="radio-label">{{method}}</span>
                  </label>
              </div>
            </div>
        </div>

        <div class="align-center-bottom">
        <ejs-button type="button" v-on:click.native="onProcessClick"
                      cssClass="e-info margin-button">Process</ejs-button>
        <ejs-button v-on:click.native="onCancelClick"
                      cssClass="e-danger margin-button">Cancel</ejs-button>
        </div>
      </div>
   </div>
</div>
</template>

<script>
import Vue from 'vue';
import { TextBoxPlugin, NumericTextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
import {
  FETCH_INVOICE_BY_ID, GET_SELECTED_INVOICE_COMPANY_BY_USERID,
  PROCESS_INVOICE_CANCEL, PROCESS_INVOICE_WO,
} from '../store';

Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(DropDownListPlugin);
Vue.use(DatePickerPlugin);

export default {
  name: 'transactionCancel',
  components: {
  },

  data() {
    return {
      invoiceId: null,
      title: 'Cancel Transaction',
      selectedInvoice: {},
      selectedInvoiceCompany: '',
      dateMarker: 'Cancel/Write Off Date(DD/MM/YYYY)',
      dateFormat: 'dd/MM/yyyy',
      datePaid: null,
      transactionNumber: '',
      paymentCancelDate: null,
      reasonNotes: '',
      cancellMethod: '',
      cancellMethods: { cancel: 'Cancel Invoice', wo: 'Write Off Invoice' },
    };
  },

  created() {
    if (this.$route.params.id !== '0') {
      this.invoiceId = this.$route.params.id;
    } else {
      this.invoiceId = '';
    }
  },

  async mounted() {
    if (this.invoiceId !== null && this.invoiceId !== '') {
      this.getSelectedInvoice(this.invoiceId);
    }
  },

  computed: {
    requestor() {
      return this.selectedInvoice.applicationRequest?.requestor;
    },
  },
  watch: {
    cancellMethod(val) {
      if (val) {
        this.dateMarker = `${val.replace('Invoice', '')} Date(DD/MM/YYYY)`;
      }
    },
  },
  methods: {
    format_currency(val) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      });
      return formatter.format(val);
    },
    async getSelectedInvoice(id) {
      try {
        await this.$store.dispatch(FETCH_INVOICE_BY_ID, { invoiceId: id });
        this.selectedInvoice = this.$store.getters.accountingSelectedInvoice;
        this.selectedInvoice.invoiceAmount = this.selectedInvoice.totalAmount
        + this.selectedInvoice.totalLevy;
      } catch (err) {
        console.error('get_invoices err', err);
        if (err.message === 'Network Error') {
          this.$router.push({ name: 'NotFound' });
        } else {
          this.$router.push({ name: 'UnAuthorized' });
        }
      }
      try {
        const { requestUserId } = this.selectedInvoice.applicationRequest;
        // eslint-disable-next-line max-len
        await this.$store.dispatch(GET_SELECTED_INVOICE_COMPANY_BY_USERID, { userId: requestUserId });
        if (this.$store.getters.accountingSelectedInvoiceCompany !== null) {
          const company = this.$store.getters.accountingSelectedInvoiceCompany;
          this.selectedInvoiceCompany = company.legalName;
        }
      } catch (err) {
        console.error(err);
      }
    },
    async onProcessClick() {
      let errorMessages = '';
      const invoice = this.selectedInvoice;

      if (!this.cancellMethod) {
        errorMessages += 'Please choice Cancel Options first;<br>';
      }
      if (!invoice.CancelRefundMetDate) {
        errorMessages += 'Cancel/Write Off Date is required;<br>';
      }
      if (!invoice.cancelRefundReason) {
        errorMessages += 'Cancel/Write Off Reason is required;';
      }
      if (errorMessages) {
        this.$parent.notificationToasts.push({
          title: 'Error!',
          content: errorMessages,
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
        if (this.$parent.notificationToasts.length > 0) {
          this.$parent.$refs.notifierRef.show();
        }
      } else {
        try {
          if (this.cancellMethod === 'Cancel Invoice') {
            await this.$store.dispatch(PROCESS_INVOICE_CANCEL, { data: invoice }).then(() => {
              this.$parent.notificationToasts.push({
                title: 'Success!',
                content: 'Transaction Cancelled successfully.',
                cssClass: 'e-toast-success',
                timeOut: 5000,
              });
            });
          } else if (this.cancellMethod === 'Write Off Invoice') {
            await this.$store.dispatch(PROCESS_INVOICE_WO, { data: invoice }).then(() => {
              this.$parent.notificationToasts.push({
                title: 'Success!',
                content: 'Write off completed successfully.',
                cssClass: 'e-toast-success',
                timeOut: 5000,
              });
            });
          }
        } catch (error) {
          this.$parent.notificationToasts.push({
            title: 'Error!',
            content: error.message,
            cssClass: 'e-toast-danger',
            timeOut: 5000,
          });
        }
        if (this.$parent.notificationToasts.length > 0) {
          this.$parent.$refs.notifierRef.show();
        }

        this.$router.push('/accounting/manage-accounting');
      }
    },
    onCancelClick() {
      this.$router.push('/accounting/manage-accounting');
    },
    getDateStringNoTime(d) {
      if (d !== null && d !== undefined) {
        const d2 = new Date(d);
        return `${d2.getFullYear()}/${d2.getMonth() + 1}/${d2.getDate()}`;
      }
      return '';
    },
  },

};
</script>

<style>
 @import '../../../assets/styles/eservices-base.css';
 .e-card-content {
  margin: 0% !important;
}

.container2 {
  display: flex;
  flex-flow: row;
  min-height: 50px;
  text-align: left;
  border-style: groove;
  margin: 10px;
  width:95%;
}

.leftcol {
  margin: 10px;
  display: flex;
  flex-direction: column;
  flex: 4;
  background-color: white;
}

.middlecol {
  margin: 10px;
  display: flex;
  flex-direction: column;
  flex: 4;
  background-color: white;
}

.colrow {
  margin: 8px;
  flex: 1;
}

.data-flex-row{
  display: flex;
  flex-direction: row;
}

.data-flex-cell{
  flex: 1;
}

h5{
  margin-top: 5px;
  margin-bottom: 5px;
}

h4{
  margin-top: 4px;
  margin-bottom: 4px;
}
</style>
